// @core/api/endpoints/authz/delete_tuples.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TupleChangeEvent,
} from '../../../types/authz';

const BASE_PATH = '/authz';

/**
 * Delete authorization tuples (internal API)
 * Removes relationship tuples from the authorization system. This is an internal API for admin or emergency use; services should publish TupleChangeEvent to the authz.tuple.delete Kafka topic for asynchronous processing with full audit trail.
 */
export async function DeleteTuples(
  data: TupleChangeEvent,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tuples/delete`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
